// App.js
import React, { useEffect } from "react";
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getUser } from "./services/operations/authAPI";

import SignUp from "./pages/auth/signup";
import LoginPage from "./pages/auth/login";
import ForgotPassword from "./pages/auth/ForgotPassword";
import UpdatePassword from "./pages/auth/updatePassword";
import UpgradePlan from "./pages/Plans/UpgradePlan";
import Dashboard from "./components/Dashboard/Dashboard";
import PrivateRoute from "./components/common/PrivateRoute";

// Teacher pages
import Teacher from "./pages/Dashboard/teacher/Teacher";
import QuetionPaper from "./pages/Dashboard/teacher/QuetionPaper";
import StudentProgress from "./pages/Dashboard/teacher/StudentProgress";
import ContentCreation from "./pages/Dashboard/teacher/ContentCreation";

// Student pages
import Student from "./pages/Dashboard/student/Student";
import UpgradePlanStudent from "./pages/Dashboard/student/UpgradePlan.jsx";
import ClassroomAI from "./pages/Dashboard/student/ClassroomAI";

// Parent + common
import Parent from "./pages/Dashboard/parent/Parent";
import Profile from "./pages/common/Profile";
import ChatBot from "./pages/chatBot/ChatBot";
import AITutorPage from "./pages/chatBot/AITutorPage";
import VerifyEmail from "./pages/auth/VerifyEmail";
import AssignmentPage from "./pages/Dashboard/student/AssignmentPage";
import TeacherAssessmentForm from "./pages/Dashboard/student/TeacherAssessmentForm";
import Admin from "./pages/Dashboard/admin/Admin";
import LibraryResource from "./components/Dashboard/Admin/LibraryResource";
import Announcements from "./components/Dashboard/Admin/Announcements";
import PolicyManagement from "./components/Dashboard/Admin/PolicyManagement";
import AICurriculumAssistant from "./components/Dashboard/Admin/AICurriculumAssistant";
import LearningPathDesigner from "./components/Dashboard/Admin/LearningPathDesigner";
import StaffAdministration from "./components/Dashboard/Admin/StaffAdministration";
import Analytics from "./components/Dashboard/Admin/Analytics";
import AddUserForm from "./components/Dashboard/Admin/AddUserForm";
import VideoUpload from "./pages/Dashboard/teacher/VideoUpload";
import SubjectsDashboard from "./components/Labs/dashboard/SubjectsDashboard.jsx";
import ChemistryLab from "./components/Labs/chemistry/ChemistryLab.jsx";
import PhysicsLab from "./components/Labs/physics/PhysicsLab.jsx";
import BiologyLab from "./components/Labs/biology/BiologyLab.jsx";
import SoftSkillBot from "./pages/Dashboard/student/softskill/SoftSkillBot";
import SoftSkill from "./pages/Dashboard/student/softskill/SoftSkill";
import ImageAssessment from "./pages/Dashboard/student/softskill/ImageAssessment";
import VoiceQuestPage from "./pages/Dashboard/student/softskill/VoiceQuestPage";
import SentenceBuilder from "./pages/Dashboard/student/softskill/SentenceBuilder.jsx";
import HabitsListPage from "./pages/Dashboard/student/habits/HabitsListPage.jsx";
import MobileAddictionLab from "./pages/Dashboard/student/habits/MobileAddictionLab.jsx";
import FoodHabitsLab from "./pages/Dashboard/student/habits/FoodHabitsLab.jsx";
import PaperEvaluation from "./pages/Dashboard/teacher/paperEvaluation/PaperEvaluation.jsx";

//Super admin mnr
import SuperAdmin from "./pages/Dashboard/superAdmin/SuperAdmin.jsx";
import SchoolManagement from "./components/Dashboard/superAdmin/SchoolManagement.jsx";
import SubscriptionManagement from "./components/Dashboard/superAdmin/SubcriptionManagement.jsx";
import UserManagement from "./components/Dashboard/superAdmin/UserManagement.jsx";
import AddSchoolPage from "./components/Dashboard/superAdmin/AddSchool.jsx";
import UserAddForm from "./components/Dashboard/superAdmin/UserAddForm.jsx";
import Subscription from "./components/Dashboard/Admin/Subscription.jsx";
import SchoolDeatils from "./components/Dashboard/superAdmin/SchoolDeatils.jsx";

// import PSTVueSubscription from "./pages/PSTVue/PSTVueSubscription.jsx";
import PSTVue from "./pages/PSTVue/PSTVue";
import PSTDataPrivacy from "./pages/PSTVue/PSTDataPrivacy.jsx";
import PSTMission from "./pages/PSTVue/PSTMission.jsx";
import PSTParent from "./pages/PSTVue/Parent.jsx";
import PSTStudent from "./pages/PSTVue/Student.jsx";
import PSTTeacher from "./pages/PSTVue/Teacher.jsx";
import Contact from "./pages/PSTVue/Contact";
import FeesManagement from "./components/Dashboard/Admin/FeesManagement.jsx";
import FeesDashboard from "./components/Dashboard/Admin/FeesDashboard.jsx";
import StudentFees from "./components/Dashboard/Admin/StudentFees.jsx";
import SetClassFees from "./components/Dashboard/Admin/SetClassFees.jsx";
import PSTVueSubscription from "./pages/PSTVue/PSTVueSubscription.jsx";
import Subject from "./pages/Dashboard/superAdmin/Subject.jsx";
import AdminRequests from "./components/Dashboard/superAdmin/AdminRequests.jsx";
import StudentRequests from "./pages/Dashboard/student/StudentRequests.jsx";
import Signup from "./pages/auth/signup";
// =====================================
const App = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem("token");

    const staticProtectedRoutes = [
      "/dashboard/student",
      "/dashboard/teacher",
      "/dashboard/parents",
      "/dashboard/admin",
      "/dashboard/profile",
      "/upgrade-plan",
    ];

    const isProtectedRoute = (pathname) => {
      return (
        pathname.startsWith("/dashboard/student/chatbot") ||
        pathname.startsWith("/dashboard/teacher/chatbot") ||
        staticProtectedRoutes.includes(pathname)
      );
    };

    const publicRoutes = [
      "/pstvue",
      "/login",
      "/signup",
      "/verify-email",
      "/forgot-password",
    ];
    if (publicRoutes.some((route) => location.pathname.startsWith(route))) {
      return;
    }

    if (token) {
      dispatch(getUser(JSON.parse(token)));
    } else if (isProtectedRoute(location.pathname)) {
      // ✅ redirect without duplicate toast
      navigate("/", { replace: true });
    }
  }, [dispatch, location.pathname, navigate]);

  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<Navigate to="/pstvue" replace />} />
      <Route path="/pstvue" element={<PSTVue />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/update-password/:token" element={<UpdatePassword />} />

      <Route path="/pstvue/mission" element={<PSTMission />} />
      <Route path="/pstvue-data-privacy" element={<PSTDataPrivacy />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/pstvue-subscription" element={<PSTVueSubscription />} />
      <Route path="/pst-apps/parent" element={<PSTParent />} />
      <Route path="/pst-apps/student" element={<PSTStudent />} />
      <Route path="/pst-apps/teacher" element={<PSTTeacher />} />

      <Route path="/portals/parent" element={<Parent />} />
      <Route path="/portals/student" element={<Student />} />
      <Route path="/portals/teacher" element={<Teacher />} />

      {/* Private Routes */}
      <Route
        path="/dashboard"
        element={
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        }
      >
        <Route path="profile" element={<Profile />} />
        <Route path="chatbot/voicebot" element={<AITutorPage />} />

        {/* Role-based redirect */}
        <Route index element={<RoleRedirect />} />

        {/* Teacher routes */}
        <Route path="teacher" element={<Teacher />} />
        <Route path="teacher/chatbot" element={<ChatBot />} />
        <Route path="teacher/chatbot/:conversationId" element={<ChatBot />} />
        <Route path="teacher/question-paper" element={<QuetionPaper />} />
        <Route path="teacher/content-creation" element={<ContentCreation />} />
        <Route path="teacher/student-progress" element={<StudentProgress />} />
        <Route path="teacher/video-upload" element={<VideoUpload />} />
        <Route path="teacher/paper-evaluation" element={<PaperEvaluation />} />
        {/* Virtual Lab routes */}
        <Route path="teacher/virtual-lab" element={<SubjectsDashboard />} />
        <Route path="teacher/chemistry" element={<ChemistryLab />} />
        <Route
          path="teacher/chemistry/:experimentId"
          element={<ChemistryLab />}
        />

        <Route path="teacher/physics" element={<PhysicsLab />} />
        <Route path="teacher/physics/:experimentId" element={<PhysicsLab />} />

        <Route path="teacher/biology" element={<BiologyLab />} />
        <Route path="teacher/biology/:experimentId" element={<BiologyLab />} />

        {/* Student routes */}
        <Route path="student" element={<Student />} />
        <Route path="student/curriculum-request" element={<StudentRequests/>} />
        <Route path="student/upgrade-plan" element={<UpgradePlanStudent />} />
        <Route path="student/chatbot" element={<ChatBot />} />
        <Route path="student/chatbot/:conversationId" element={<ChatBot />} />

        <Route path="student/classroomai" element={<ClassroomAI />} />
        <Route path="student/assignment/:id" element={<AssignmentPage />} />
        <Route path="student/assessment" element={<TeacherAssessmentForm />} />
        <Route path="student/soft-skills" element={<SoftSkill />} />
        <Route
          path="student/soft-skills/voice-bot"
          element={<SoftSkillBot />}
        />
        <Route
          path="student/soft-skills/image-assessment"
          element={<ImageAssessment />}
        />
        <Route
          path="student/soft-skills/voice-quest"
          element={<VoiceQuestPage />}
        />
        <Route path="student/soft-skills" element={<SoftSkill />} />
        <Route
          path="student/soft-skills/voice-bot"
          element={<SoftSkillBot />}
        />
        <Route
          path="student/soft-skills/image-assessment"
          element={<ImageAssessment />}
        />
        <Route
          path="student/soft-skills/voice-quest"
          element={<VoiceQuestPage />}
        />
        <Route
          path="student/soft-skills/sentence-builder"
          element={<SentenceBuilder />}
        />
        {/* Virtual Lab routes */}
        <Route path="student/virtual-lab" element={<SubjectsDashboard />} />
        <Route path="student/chemistry" element={<ChemistryLab />} />
        <Route
          path="student/chemistry/:experimentId"
          element={<ChemistryLab />}
        />

        <Route path="student/physics" element={<PhysicsLab />} />
        <Route path="student/physics/:experimentId" element={<PhysicsLab />} />

        <Route path="student/biology" element={<BiologyLab />} />
        <Route path="student/biology/:experimentId" element={<BiologyLab />} />

        <Route path="student/habits" element={<HabitsListPage />} />
        <Route path="student/habits/mobile" element={<MobileAddictionLab />} />
        <Route path="student/habits/food" element={<FoodHabitsLab />} />

        {/* Parent route */}
        <Route path="parents" element={<Parent />} />

        {/*School Admin route */}
        <Route path="admin/signup" element={<SignUp />} />
        <Route path="admin" element={<Admin />} />
        <Route path="admin/curriculum" element={<AICurriculumAssistant />} />
        <Route path="admin/paths" element={<LearningPathDesigner />} />
        <Route path="admin/staff" element={<StaffAdministration />} />
        <Route path="admin/staff/add-user" element={<AddUserForm />} />
        <Route path="admin/analytics" element={<Analytics />} />
        <Route path="admin/fees-management" element={<StudentFees />} />
        {/* <Route path="admin/fees-management/student-fees" element={<StudentFees />} /> */}
        {/* <Route path="admin/fees-management/set-class-fees" element={<SetClassFees />}  /> */}
        <Route
          path="admin/fees-management/student-fees/fees-details/:studentId"
          element={<FeesDashboard />}
        />
        <Route path="admin/library" element={<LibraryResource />} />
        <Route path="admin/policy" element={<PolicyManagement />} />
        <Route path="admin/announcements" element={<Announcements />} />
        <Route path="admin/subscription" element={<Subscription />} />

        {/* Super ADMIN route (MNR) */}
        <Route path="super-admin" element={<SuperAdmin />} />
        <Route path="super-admin/subject-manager" element={<Subject />} />
        <Route path="super-admin/subject-request" element={<AdminRequests/>} />
        <Route path="super-admin/schools" element={<SchoolManagement />} />
        <Route
          path="super-admin/schools/add-school"
          element={<AddSchoolPage />}
        />
        <Route
          path="/dashboard/super-admin/schools/:id"
          element={<SchoolDeatils />}
        />
        <Route
          path="super-admin/subscriptions"
          element={<SubscriptionManagement />}
        />
        <Route path="super-admin/users" element={<UserManagement />} />
        <Route path="super-admin/users/add-user" element={<UserAddForm />} />
      </Route>

      <Route
        path="/upgrade-plan"
        element={
          <PrivateRoute>
            <UpgradePlan />
          </PrivateRoute>
        }
      />
    </Routes>
  );
};

// 🔹 Helper for role-based dashboard redirect

function RoleRedirect() {
  const { user } = useSelector((state) => state.profile);

  if (user?.role === "teacher") return <Navigate to="teacher" replace />;
  if (user?.role === "student") return <Navigate to="student" replace />;
  if (user?.role === "parent") return <Navigate to="parents" replace />;
  if (user?.role === "school_admin") return <Navigate to="admin" replace />;
  if (user?.role === "super_admin")
    return <Navigate to="super-admin" replace />;
  return <div>Invalid role</div>;
}

export default App;
